'use strict'

/**
 * MODULE INSCRIPTION
 */

import inscriptionGoogleAPI from 'Modules/inscriptionGoogleAPI'
import password from 'Modules/password'
import inscriptionConnexionCustomAction from 'Modules/inscriptionConnexionCustomAction'
import ajaxLoader from 'Modules/ajaxLoader'
import adresseForm from 'Modules/adresseForm'
import ajaxManagement from 'Modules/ajaxManagement'
import ads from 'Modules/ads'
import urlModule from 'Modules/url'
import { _500 } from 'Modules/Resources/Error'
import master from 'Modules/master'

const FORM_VALIDATION_EMAIL = '.j-verification-email'
const FORM_VERIFICATION_PASSWORD = '.j-verification-password'
const FORM_INSCRIPTION = '.j-inscription'
const FORM_CONNEXION = '.j-connexion'
const INPUT_EMAILLOGIN = '.j_bsForm_email'
const INPUT_PASSWORD = '.j_password'
const INPUT_TELEPHONE = '.j-telephone'
const INPUT_USEADBLOCK = '.j-useAdBlock'
const J_INSCRIPTION_ERROR = '.j_inscription_error'
const J_DATA_REFERER = 'referer'
const J_DATA_RELOAD = 'reload'
const J_MODAL = '.j_modal_wishlist_catalogue'
const SUBMIT_INSCRITION_CONNEXION = '.j_submit_inscription'
const SUBMIT_CONNEXION = '.j_submit_connexion'
const J_SELECT_PAYS = '.j_select_autresPays'
const J_DATE_JOUR = '.j_dateJour'
const J_DATE_MOIS = '.j_dateMois'
const J_DATE_ANNEE = '.j_dateAnnee'
const J_DATE_NAISSANCE = '.j_date_naissance'
const J_DATE_NAISSANCEPART = '.j_date_naissance_part'

let validatorInscription = ''

function Process() {
    password.setEventForPrintingPassword() // afficher/masquer le mot de passe

    inscriptionConnexionCustomAction.setEventToolTipsOnBirthDay()

    inscriptionGoogleAPI.Process(
        $('.js-group-google'),
        $('.js-input-google'),
        $('.group-autocomplete'),
        $('.autocomplete'),
        $('.j-inscription')
    )

    $(J_MODAL).on('hide.bs.modal', function (e) {
        $(FORM_VALIDATION_EMAIL).show()
        $(FORM_VERIFICATION_PASSWORD).hide()
        $(FORM_INSCRIPTION).hide()
    })

    if ($('#isInscription').val() == 0) {
        ProcessInscription()
    }
    $('form').filter(FORM_VALIDATION_EMAIL).bootstrapValidator()

    const validatorEmail = $('form')
        .filter(FORM_VALIDATION_EMAIL)
        .data('bootstrapValidator')

    $(FORM_VALIDATION_EMAIL).on('success.form.bv', function (event) {
        event.preventDefault()

        if (validatorEmail.isValid()) {
            ajaxLoader.loadAndExecuteCallBack(
                'POST',
                $(this).serialize(),
                function (reponse) {
                    // si l'email est invalidé par le serveur
                    if (reponse.EmailValid === false) {
                        validatorEmail.updateStatus(
                            'email',
                            'INVALID',
                            'emailAddress'
                        )
                    }
                    // si l'email existe on demande le mot de passe
                    else if (
                        reponse.EmailExist === true &&
                        reponse.IsInscription3M === false
                    ) {
                        // on cache le formulaire contenant l'email
                        $(FORM_VALIDATION_EMAIL).hide()
                        // on affiche le formulaire contenant le mdp
                        $(FORM_VERIFICATION_PASSWORD).show()

                        // on copie l'email
                        const email = $(
                            FORM_VALIDATION_EMAIL + ' ' + INPUT_EMAILLOGIN
                        ).val()
                        $(
                            FORM_VERIFICATION_PASSWORD + ' ' + INPUT_EMAILLOGIN
                        ).val(email)
                        $(INPUT_PASSWORD).focus()
                        $(
                            FORM_VERIFICATION_PASSWORD + ' ' + INPUT_EMAILLOGIN
                        ).attr('name', 'email')
                        ProcessVerificationPassword()

                        validatorEmail.resetForm()
                    } else {
                        // sinon on affiche le formulaire d'inscription
                        // on cache le formulaire contenant l'email
                        $(FORM_VALIDATION_EMAIL).hide()

                        // on affiche le formulaire d'inscription
                        $(FORM_INSCRIPTION).show()

                        // on copie l'email dans l'input d'inscription
                        const email = $(FORM_VALIDATION_EMAIL)
                            .find(INPUT_EMAILLOGIN)
                            .val()
                        $(FORM_INSCRIPTION).find(INPUT_EMAILLOGIN).val(email)
                        ProcessInscription()

                        validatorEmail.resetForm()
                    }
                },
                function () {
                    const $location = $(J_INSCRIPTION_ERROR)
                    $location.empty().append(_500)
                },
                $(this).attr('action')
            )
        }
    })

// gestion de la page de connexion
    if ($(FORM_CONNEXION)[0]) {
        
        ProcessConnexion()
    }

}

function ProcessConnexion() {
    $('form').filter(FORM_CONNEXION).bootstrapValidator()
    const validatorConnexion = $('form')
        .filter(FORM_CONNEXION)
        .data('bootstrapValidator')
    $(FORM_CONNEXION).on('success.form.bv', function (event) {
        event.preventDefault()
        ajaxLoader.loadAndExecuteCallBack(
            'POST',
            $(FORM_CONNEXION).serialize(),
            function (reponse) {
                // si le mdp est correct
                if (reponse.Result === true) {
                    window.location = reponse.Redirect
                } else {
                    validatorConnexion.updateStatus($(INPUT_PASSWORD), 'INVALID')
                    validatorConnexion.updateMessage(
                        $(INPUT_PASSWORD),
                        'notEmpty',
                        $('#error-message').val()
                    )
                }
            },
            function () {
                const $location = $(J_INSCRIPTION_ERROR)
                $location.empty().append(_500)
            },
            $(FORM_CONNEXION).attr('action')
        )


        
    })
}

function ProcessVerificationPassword() {
    $('form').filter(FORM_VERIFICATION_PASSWORD).bootstrapValidator()
    const validatorPassword = $('form')
        .filter(FORM_VERIFICATION_PASSWORD)
        .data('bootstrapValidator')

    $(FORM_VERIFICATION_PASSWORD).on('success.form.bv', function (event) {
        $(INPUT_USEADBLOCK).val(ads.useAdBlocker())
        event.preventDefault()
        const form = $(this)

        ajaxLoader.loadAndExecuteCallBack(
            'POST',
            $(this).serialize(),
            function (reponse) {
                // si le mdp est correct
                if (reponse.Result === true) {
                    
                    closeOrReload(form, 'connexion')
                } else {
                    validatorPassword.updateStatus($(INPUT_PASSWORD), 'INVALID')
                    validatorPassword.updateMessage(
                        $(INPUT_PASSWORD),
                        'notEmpty',
                        reponse.Message
                    )
                }
            },
            function () {
                const $location = $(J_INSCRIPTION_ERROR)
                $location.empty().append(_500)
            },
            $(this).attr('action')
        )
    })

    $(INPUT_PASSWORD).blur(function () {
        if ($(this).val() == '') {
            validatorPassword
                .updateStatus($(INPUT_PASSWORD), 'INVALID')
                .updateMessage(
                    $(INPUT_PASSWORD),
                    'notEmpty',
                    $('#notempty-message').val()
                )
        }
    })
}

function ProcessInscription() {
    adresseForm.setEventOnComplementAdresseLink() // gestion du lien Complement d'adresse
    adresseForm.setEventForGettingVillesByCodePostal() // Gestion de l'affichage des villes via le code postal
    adresseForm.manageValidIconTelephone() // On efface les icones valides des cases téléphone sauf si c'est la derniere
    adresseForm.changeSettingsByPays()
    adresseForm.setEventForPrintingOtherPays()
    adresseForm.showVilleFieldWhenSelectingAutresVilles()

    $('form').filter(FORM_INSCRIPTION).bootstrapValidator()
    validatorInscription = $('form')
        .filter(FORM_INSCRIPTION)
        .data('bootstrapValidator')

    $("[name='passwordInscr']").focus()

    $('.j_select_indicatifTel')
        .find('option')
        .each(function () {
            const data = '+' + $(this).val()
            const tel = $(INPUT_TELEPHONE).val()
            const indicatif = tel.substring(0, 3)

            if (data == indicatif) {
                $('.j_select_indicatifTel').val($(this).val())
                $(INPUT_TELEPHONE).val(
                    $(INPUT_TELEPHONE)
                        .val()
                        .substring(data.length, $(INPUT_TELEPHONE).val())
                )
                $(INPUT_TELEPHONE).blur()
            }
        })

    $('.j_submit_inscription').click(function () {
        validatorInscription.validate()
    })

    $(INPUT_TELEPHONE).keyup(function () {
        let telephone = $(this).val()

        if (
            $("[name='codePays']").val() == 'FR' &&
            $(this).val().length == 10 &&
            $(this).val().substring(0, 1) == '0'
        ) {
            telephone = telephone.substring(1, 10)
            // $(this).val($(this).val().substring(1, 10));
        }

        const pattern = $('.js-regex-telephone')
            .filter(
                '[data-indicatiftel="' +
                $('.j_select_indicatifTel :selected').val() +
                '"]'
            )
            .val()

        telephone =
            '+' + $('.j_select_indicatifTel :selected').val() + telephone

        $('#hiddentel').val(telephone)

        if (pattern !== '') {
            const regex = new RegExp(pattern)

            if (!regex.test(telephone)) {
                validatorInscription.updateStatus(
                    $(INPUT_TELEPHONE),
                    'INVALID',
                    'regexp'
                )
            } else {
                validatorInscription.updateStatus(
                    $(INPUT_TELEPHONE),
                    'VALID',
                    'regexp'
                )
            }
        } else {
            if ($(this).val() !== '') {
                validatorInscription.updateStatus($(INPUT_TELEPHONE), 'VALID')
            }
        }
    })

    $(J_SELECT_PAYS).change(function () {
        $('.j_select_indicatifTel').val(
            $('.j_select_indicatifTel')
                .find('[data-codepays="' + $(this).val() + '"]')
                .val()
        )
        $('.j_select_indicatifTel').change()
    })

    $('.j_select_indicatifTel').change(function () {
        $(INPUT_TELEPHONE).blur()
    })

    $(FORM_INSCRIPTION).on('success.form.bv', function (event) {
        event.preventDefault()

        $(INPUT_USEADBLOCK).val(ads.useAdBlocker())
        const form = $(this)

        ajaxLoader.loadAndExecuteCallBack(
            'POST',
            $(this).serialize(),
            function (reponse) {
                // si le mdp est correct
                if (reponse.Result === true) {
                    closeOrReload(form, 'inscription')
                } else {
                    $(J_INSCRIPTION_ERROR).empty().append(reponse.Message)
                    $('.j-adress_manuel').click()
                    $(SUBMIT_INSCRITION_CONNEXION).removeAttr('disabled')
                }
            },
            function () {
                // En cas d'échec on affiche une erreur

                $(J_INSCRIPTION_ERROR).empty().append(_500)
                $('.j-adress_manuel').click()
                $(SUBMIT_INSCRITION_CONNEXION).removeAttr('disabled')
            },
            $(this).attr('action')
        )
    })

    $(J_DATE_NAISSANCEPART).on('keyup', function () {
        const jour = $(J_DATE_JOUR).val()
        const mois = $(J_DATE_MOIS).val()
        const annee = $(J_DATE_ANNEE).val()

        if (jour != '' && mois != '' && annee != '') {
            const datefinal = jour + '/' + mois + '/' + annee

            $(J_DATE_NAISSANCE).val(datefinal)
        } else {
            $(J_DATE_NAISSANCE).val('')
        }
    })

    $(J_DATE_JOUR).on('keyup', function () {
        if ($(this).val() == '') {
            $(this).removeClass('has-success')
            $(this).removeClass('has-error')
            $('.error-jour').hide()
            return
        }

        const reg = /^[0-9]*$/
        if (reg.test($(this).val()) && $(this).val() < 32 && $(this).val() > 0) {
            $(this).addClass('has-success')
            $(this).removeClass('has-error')
            $('.error-jour').hide()
        } else {
            $(this).addClass('has-error')
            $(this).removeClass('has-success')
            $('.error-jour').show()
        }
    })
    $(J_DATE_MOIS).on('keyup', function () {
        if ($(this).val() == '') {
            $(this).removeClass('has-success')
            $(this).removeClass('has-error')
            $('.error-mois').hide()
            return
        }

        const reg = /^[0-9]*$/
        if (
            reg.test($(J_DATE_MOIS).val()) &&
            $(J_DATE_MOIS).val() < 13 &&
            $(J_DATE_MOIS).val() > 0
        ) {
            $(J_DATE_MOIS).addClass('has-success')
            $(J_DATE_MOIS).removeClass('has-error')
            $('.error-mois').hide()
        } else {
            $(J_DATE_MOIS).addClass('has-error')
            $(J_DATE_MOIS).removeClass('has-success')
            $('.error-mois').show()
        }
    })
    $(J_DATE_ANNEE).on('keyup', function () {
        if ($(this).val() == '') {
            $(this).removeClass('has-success')
            $(this).removeClass('has-error')
            $('.error-annee').hide()
            return
        }

        const reg = /^[0-9]*$/
        const ladate = new Date()
        const anneemajorite = ladate.getFullYear() - 16 // Gère l'année de naissance pour les personnes "majeures"
        if (
            reg.test($(J_DATE_ANNEE).val()) &&
            $(J_DATE_ANNEE).val() < anneemajorite &&
            $(J_DATE_ANNEE).val() > 1900
        ) {
            $(J_DATE_ANNEE).addClass('has-success')
            $(J_DATE_ANNEE).removeClass('has-error')
            $('.error-annee').hide()
        } else {
            $(J_DATE_ANNEE).addClass('has-error')
            $(J_DATE_ANNEE).removeClass('has-success')
            $('.error-annee').show()
        }
    })
}

function closeOrReload(form, eventname) {
    const reload = $(SUBMIT_INSCRITION_CONNEXION).data(J_DATA_RELOAD)
    const referer = $(SUBMIT_INSCRITION_CONNEXION).data(J_DATA_REFERER)
    let loginaction = 'default'
    let relocateUrl = ''
    const redirectionUrl = urlModule.parseRedirectionParameter()

    if (redirectionUrl !== undefined && redirectionUrl !== '') {
        relocateUrl = redirectionUrl
        loginaction = 'panier'
    } else {
        if (referer !== undefined) {
            relocateUrl = referer
            loginaction = 'referer'
        } else {
            relocateUrl = '/'
            loginaction = 'home'
        }
    }

    // Remontée de l'information vers analytics
    relocateUrl = decodeURIComponent(relocateUrl)
    if (window.google_tag_manager && window.ga && window.ga.create) {
        window.dataLayer.push({
            event: eventname,
            event_action: loginaction,
            event_label: 'form'
        })
    }

    if (reload == 1) {
        window.location.replace(relocateUrl)
    } else {
        $(J_MODAL).modal('hide')

        ajaxManagement.CallLast(function () {
            $.ajax({
                type: 'GET',
                url: '/Layout/GetInfoConnexion',
                success: function (jsReturnArgs) {
                    $('.zone-header').replaceWith(jsReturnArgs)

                    master.process()

                    $('.manage_profil').attr('href', '/club/profils/')
                }
            })
        })
    }
}

export default {
    Process: Process
}
